import { Container, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import React from 'react';


function Section({title, color, backgroundColor, children, innerRef}: {title: string, color:string, backgroundColor: string, children: React.ReactNode, innerRef: React.RefObject<HTMLElement>}) {
  return (
    <Box
      sx={{ backgroundColor, width: "100%", padding: "50px 0" }}
      ref={innerRef}
    >
      <Container maxWidth="md">
        <Typography
          id={title}
          variant="h4"
          component="h1"
          sx={{ color, mb: 2, textAlign: "left", fontWeight: 500, fontFamily: 'spinwerad', letterSpacing: 3 }}
        >
          {title}
        </Typography>
        {children}
      </Container>
    </Box>
  );
}

export default Section;